import styled from 'styled-components';
import { Callout } from '../../callout';

export const DateRangePickerCallout = styled(Callout)`
    border-style: ${({ theme: { dateRangePicker: { composites } } }) => composites.calloutBorderStyle};
    border-width: ${({ theme: { dateRangePicker: { composites } } }) => composites.calloutBorderWidth};
    border-color: ${({ theme: { dateRangePicker: { colors } } }) => colors.calloutBorderColor};
`;
